import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps, webpageProps } from 'js/analytics/standardizedProps'

export const trackPageView = () => {
  const properties = {
    url: document.location.href,
    pathname: document.location.pathname,
    title: document.title,
  }
  ga.page(properties)
  amplitude.track('user_view_page', {
    ...baseWebEventProps(),
    ...webpageProps(),
    action_name: 'view',
    action_type: 'active',
    page_view_type: 'page_view',
  })
}
